// src/pages/FeedbackForm.js
import React, { useState } from 'react';
import './FeedbackForm.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function FeedbackForm() {
  const { t } = useTranslation('feedback');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/send_feedback_email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          email,
          message
        })
      });

      if (response.ok) {
        setStatus('success');
        setName('');
        setEmail('');
        setMessage('');
        setTimeout(() => navigate('/hub'), 2000);
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Erro ao enviar sugestão:', error);
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='feedback-form-box'>
      <div className="feedback-form-container">
        <h2>{t('feedbackTitle')}</h2>
        <form onSubmit={handleSubmit} className="feedback-form">
          <label>{t('nameLabel')}</label>
          <input type="text" value={name} onChange={e => setName(e.target.value)} required />

          <label>{t('emailLabel')}</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />

          <label>{t('commentLabel')}</label>
          <textarea value={message} onChange={e => setMessage(e.target.value)} rows="6" required />

          <button className='feedback-submit-button' type="submit" disabled={isSubmitting}>{t('sendButton')}</button>
          {status === 'success' && <p className="feedback-success">{t('successMessage')}</p>}
          {status === 'error' && <p className="feedback-error">{t('errorMessage')}</p>}
        </form>
      </div>
    </div>
    
  );
}

export default FeedbackForm;
